import React, { useEffect, useState } from "react";
import PdfViewer from "../../../../HwManagement/PdfViewer/PdfViewer";
import { IP } from "./../../../../internalServer"
import { useSelector } from "react-redux";
import { Player } from "video-react";
import { iconData } from "../../../../iconData";

export default function SubmisshionByUpload({
  question,
  questionNo,
  setQuestionsAnswer,
  questionsAnswer,
  adaptive
}) {
  const [responseAttach, setResponseAttach] = useState();
  const [answerLimit, setAnswerLimit] = useState(
    question?.type?.maxLimit ? question?.type?.maxLimit : 2500
  );
  useEffect(() => {
    setAnswerLimit(question?.type?.maxLimit);
  }, [question?.type]);
  const userId = useSelector((state) => state?.user?.currentUser?.id);
  const [pedingSubDetail, setPedingSubDetail] = useState({
    pdfView: false,
    attachment: null,
  });
  const [isClicked, setIsClicked] = useState(false);
  const handleClick = (attachment) => {
    setResponseAttach(attachment);
    setIsClicked(!isClicked);
  };
  const [isOpen, setIsOpen] = useState(false);
  const [isError, setIsError] = useState(false);
  const handleRemovePdfVivwer = () => {
    setPedingSubDetail({
      ...pedingSubDetail,
      pdfView: false,
      attachment: null,
    });
    setIsOpen(null);
  };

  return (
    <>
      <div className="containerBelowQuestion">
        <div className="d-flex justify-content-between">
          <div className="Question">
            {adaptive ? null : (`Q${questionNo}.  `)}{question?.title?.split("\n").map((line, index) => (
              <React.Fragment key={index}>
                {index !== 0 && <br />}
                <span style={index !== 0 ? { marginLeft: "30px", display: "inline-block" } : {}}>
                  {line}
                </span>
              </React.Fragment>
            ))}

            {question?.is_mandatory && (
              <span
                style={{
                  marginLeft: "20px",
                  color: "#AC1616",
                  fontSize: "10px",
                  fontWeight: "700",
                }}
              >
                *Mandatory
              </span>
            )}
          </div>
        </div>
        {question?.attachments?.length > 0 &&
          question?.attachments?.map((attachment, index) => (
            <div key={index}>
              {attachment.split(".").pop() !== "mp4" ? (
                <>
                  {attachment.split(".").pop() === "jpg" ||
                    attachment.split(".").pop() === "jpeg" ||
                    attachment.split(".").pop() === "JPEG" ||
                    attachment.split(".").pop() === "JPG" ||
                    attachment.split(".").pop() === "PNG" ||
                    attachment.split(".").pop() === "png" ? (
                    <img
                      style={{ cursor: "pointer" }}
                      className="mt-3 imageWidthAndHeight"
                      src={IP + attachment?.replace(/^\./, "")}
                      alt="Attachment"
                      onClick={() => {
                        if (!isError) {
                          handleClick(attachment);
                        }
                      }}
                    />
                  ) : (
                    <div
                      key={index}
                      onClick={(e) =>
                        setPedingSubDetail({
                          ...pedingSubDetail,
                          pdfView: true,
                          attachment: attachment,
                        })
                      }
                      className="mt-2"
                    >
                      <div className="d-flex pdfContainer gap-2 p-2 "
                        onClick={() => {
                          if (!isError) {
                            handleClick(attachment);
                          }
                        }}>
                        <div className="d-flex align-items-center">
                          <img
                            className="extention_icon"
                            src={`${iconData?.find(
                              (i) =>
                                i.extension ===
                                attachment?.match(/\.([^.]+)$/)[1]
                            )?.icon
                              }`}
                            alt=""
                          />
                        </div>
                        <div className="w-100">
                          <div
                            className="pdfName"
                            title={attachment?.replace(/^[^_]*_/, "")}
                          >
                            {attachment?.replace(/^[^_]*_/, "")}
                          </div>
                          <div className="pdfFileSize">12 KB</div>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              ) : (
                <div className="d-flex pdfContainer gap-2 p-2"
                  onClick={() => {
                    if (!isError) {
                      handleClick(attachment);
                    }
                  }}>
                  <div className="d-flex align-items-center">
                    <img
                      className="extention_icon"
                      src={`${iconData?.find(
                        (i) =>
                          i.extension ===
                          attachment?.match(/\.([^.]+)$/)[1]
                      )?.icon
                        }`}
                      alt=""
                    />
                  </div>
                  <div className="w-100">
                    <div
                      className="pdfName"
                      title={attachment?.replace(/^[^_]*_/, "")}
                    >
                      {attachment?.replace(/^[^_]*_/, "")}
                    </div>
                    <div className="pdfFileSize">12 KB</div>
                  </div>
                </div>
              )}
            </div>
          ))}

        <div style={{ position: "relative" }} className="mt-3 mb-3">
          <textarea
            placeholder="Type to write your answer here."
            className="textInputQuestion p-3"
            maxLength={answerLimit}
            value={
              questionsAnswer.find((i) => i.question_id === question?.id)
                ?.description
            }
            onChange={(e) =>
              setQuestionsAnswer((prev) => {
                let updatedData = prev.map((item) => {
                  if (item.question_id === question?.id) {
                    return {
                      ...item,
                      description: e.target.value,
                    };
                  }
                  return item;
                });
                if (
                  !updatedData.some((item) => item.question_id === question?.id)
                ) {
                  updatedData.push({
                    question_id: question?.id,
                    description: e.target.value,
                  });
                }

                return updatedData;
              })
            }
          ></textarea>
          <div
            className="maxWordCount"
            style={{
              position: "absolute",
              bottom: "10px",
              right: "10px",
            }}
          >
            {
              questionsAnswer.find((i) => i.question_id === question?.id)
                ?.description?.length
            }
            /{answerLimit}
          </div>
        </div>
      </div>
      {pedingSubDetail.pdfView && (
        <PdfViewer
          handleRemovePdfVivwer={handleRemovePdfVivwer}
          attachment={pedingSubDetail?.attachment}
        />
      )}
      {isClicked &&
        (responseAttach.split(".").pop() === "mp4" || responseAttach.split(".").pop() === "MP4" ? (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              <video className="videoPlayer" controls>
                <source src={IP + responseAttach.replace(/^\./, "")} type="video/mp4" />
              </video>
              <div>
                <img
                  className="crossIconImgQue"
                  onClick={handleClick}
                  src="/DCM-img/crossIcon.svg"
                  alt="Up Arrow"
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              {
                !isError ? (
                  <>
                    <img
                      className="imgMain"
                      src={IP + responseAttach?.replace(/^\./, "")}
                      alt="Full-size"
                      onError={(e) => {
                        setIsError(true)
                      }}
                    />
                    <div>
                      <img
                        className="crossIconImgQue"
                        onClick={handleClick}
                        src="/images/cross.png"
                        alt="Up Arrow"
                      />
                    </div>
                  </>
                ) : (
                  <div className="fullSizeImg" style={{ display: "flex", flexDirection: "column" }}>
                    <img
                      onClick={() => {
                        setIsError(false)
                        handleClick()
                      }}
                      src="/images/cross.png"
                      alt="Up Arrow"
                      style={{ position: "absolute", top: "75px", right: "40%" }}
                    />
                    <img src="/images/no-photo1.png" alt="img" style={{ width: "25%" }} />
                    <p style={{ color: "red", fontSize: "20px", fontWeight: "500", marginRight: "35px" }}>Error!! failed to load the requested file!</p>
                  </div>
                )
              }
            </div>
          </div>
        ))}
    </>
  );
}
